<template>
  <div id="choose-product" class="tw-w-full tw-px-4 md:tw-px-0 md:tw-w-10/12 tw-mt-12 tw-mb-6 tw-flex tw-flex-wrap tw-justify-between tw-pb-5">
    <v-card
        id="motor-insurance"
        class="mx-auto tw-full md:tw-w-64 tw-px-3 tw-py-3 md:tw-py-8 tw-flex tw-flex-wrap tw-justify-center tw-bg-left-bottom bg-size tw-mt-6 md:tw-mt-3" flat

    >
      <v-icon color="primary" size="70" alt="car">mdi-hospital-box-outline</v-icon>
      <div class="tw-w-full tw-flex tw-flex-wrap tw-justify-center">
        <h3 class="c-blue-text  title-font tw-text-base tw-px-3 tw-mt-4">Maternity</h3>
        <p class="c-gray-text tw-w-full tw-text-sm tw-text-center">The future looks promising for my partner and I</p>
        <v-btn color="primary" class="my-3" @click="proceedNext('maternity')">
          Proceed
        </v-btn>
      </div>
    </v-card>
    <v-card
        id="motor-insurance"
        class="mx-auto tw-full md:tw-w-64 tw-px-3 tw-py-3 md:tw-py-8 tw-flex tw-flex-wrap tw-justify-center tw-bg-left-bottom bg-size tw-mt-6 md:tw-mt-3"
        flat
    >
      <v-icon color="primary" size="70" alt="car">mdi-thermometer-lines</v-icon>
      <div class="tw-w-full tw-flex tw-flex-wrap tw-justify-center">
        <h3 class="c-blue-text  title-font tw-text-base tw-px-3 tw-mt-4">Outpatient</h3>
        <p class="c-gray-text tw-w-full tw-text-sm tw-text-center">Incase of quick medical emergencies, might need this
        </p>
        <v-btn color="primary" class="my-3"  @click="proceedNext('outpatient')">
          Proceed
        </v-btn>
      </div>
    </v-card>
    <v-card
        id="motor-insurance"
        class="mx-auto tw-full md:tw-w-64 tw-px-3 tw-py-3 md:tw-py-8 tw-flex tw-flex-wrap tw-justify-center tw-bg-left-bottom bg-size tw-mt-6 md:tw-mt-3"
        flat
    >
      <div>
        <v-icon color="primary" size="70" alt="car">mdi-hospital-box-outline</v-icon>
        <v-icon color="primary" size="60" alt="car">mdi-thermometer-lines</v-icon>
      </div>
      <div class="tw-w-full tw-flex tw-flex-wrap tw-justify-center">
        <h3 class="c-blue-text  title-font tw-text-base tw-px-3 tw-mt-4">Maternity & Outpatient</h3>
        <p class="c-gray-text tw-w-full tw-text-sm tw-text-center">I’ll take both for my family and I
        </p>
        <v-btn color="primary" class="my-3"  @click="proceedNext('both')">
          Proceed
        </v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'SelectAdditionalBenefits',
  methods: {
    proceedNext(choice) {
      this.$emit('proceed-to-health-benefit-limits', choice);
    },
  },
};
</script>
